<mat-dialog-content class="mat-typography image-popup">
  @if (imageUrl) {
    <img [src]="imageUrl" />
  }
  @if (!imageUrl) {
    <p>No Image</p>
  }
</mat-dialog-content>
